import React from 'react';
import { Link } from 'react-router-dom';
import '../../components/InfoPages.css';

const AboutUs = () => {
    return (
        <div className="info-page-container">
            <header className="info-page-header">
                <Link to="/" className="back-link">← Back to Home</Link>
                <h1>Built for a better kind of screen time.</h1>
            </header>

            <main className="info-page-content">
                <section>
                    <h2>Our Mission</h2>
                    <p>
                        Your downtime has value. <strong>Ernify</strong> brings games and reward activities together in one straightforward Android app, with clear coin balances, reward limits and payout eligibility shown as you go.
                    </p>
                </section>

                <section>
                    <h2>What we believe in</h2>
                    <ul>
                        <li><strong>Clarity first.</strong> Coin conversion, daily limits and withdrawal requirements should never be a surprise.</li>
                        <li><strong>Games people enjoy.</strong> Pick a short game when you want a break, then see your progress directly in the app.</li>
                        <li><strong>Rewards with rules.</strong> Eligible users can request cash withdrawals after meeting the in-app threshold and review requirements.</li>
                    </ul>
                </section>

                <section className="cta-small">
                    <p>Ready to make your next break more rewarding?</p>
                    <a href="https://play.google.com/store/apps/details?id=com.ernify" target="_blank" rel="noopener noreferrer" className="download-link-small">
                        Get the App
                    </a>
                </section>
            </main>

            <footer className="info-page-footer">
                <p>&copy; {new Date().getFullYear()} Ernify. Made with 🧡.</p>
            </footer>
        </div>
    );
};

export default AboutUs;
